import BaseIncomingPayload from "./base-incoming-payload.ts";
import IncomingPayloadEvent from "../../enums/incoming-payload-event.ts";
import ParseUtils from "../../utils/parse-utils.ts";

export default class V1Error extends BaseIncomingPayload {
  public readonly message: string;

  constructor(payload: Record<string, unknown>) {
    super(payload, IncomingPayloadEvent.V1_ERROR);

    this.message = ParseUtils.parseString(payload, "message");
  }
}
